import { useContext, useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { BsCheckLg } from 'react-icons/bs';
import PropTypes from 'prop-types';

import { partesTrabajoDiarioItemsWorkReport } from '../../../../../utils/globalPropTypes';
import ConditionalWrapper from '../../../../ConditionalWrapper/ConditionalWrapper';
import LoaderContext from '../../../../../context/LoaderProvider';
import useToast from '../../../../../hooks/useToast';
import './AcceptButton.scss';
import { ubicationTypeEnum } from '../../../../../utils/dataStatus';
import { useWorkReportModals } from '../../../../../context/WorkReportModalsContext';
import { getLocationProgramPointAdapter } from '../../../../../services/programPointsService';
import useLocationProgramPoints from '../../../../WorkReportModals/ProgramPointModal/useLocationProgramPoints';

const AcceptButton = ({ dailyWorkReport, fetchData, selectedDate }) => {
  const [disabledButton, setDisableButton] = useState(false);
  const { setNewToast } = useToast();
  const selectedDateFormated = new Date(selectedDate);
  const today = new Date();
  const todayOlderThanSelectedDate = today < selectedDateFormated;
  const { setLoader } = useContext(LoaderContext);
  const { activeAcceptModal } = useWorkReportModals();

  const { approveLocationProgramPoints, approve } = useLocationProgramPoints({
    line: dailyWorkReport
  });

  const AcceptQuantity = async () => {
    try {
      setLoader(true);
      setDisableButton(true);
      if (
        dailyWorkReport?.tipoUbicacionEnum === ubicationTypeEnum.pozo ||
        dailyWorkReport?.tipoUbicacionEnum === ubicationTypeEnum.locacion
      ) {
        // Primera consulta para obtener los puntos de programa

        const locations = await getLocationProgramPointAdapter(dailyWorkReport);

        const hasOperativeData = locations.some((location) =>
          location.programPoints.some(
            (pp) => pp?.code || pp?.subCode || pp?.detail || pp?.clasification || pp?.cost
          )
        );

        if (hasOperativeData) {
          await approveLocationProgramPoints(locations);
          fetchData();
        } else {
          activeAcceptModal({
            daily: dailyWorkReport,
            fetchData,
            line: {
              positionName: dailyWorkReport?.posicionSap,
              lineName: dailyWorkReport?.lineaSap,
              idParteDiario: dailyWorkReport?.idParteDiario,
              estadoEnum: dailyWorkReport?.estadoEnum,
              tienePuntosPrograma: dailyWorkReport?.notificaPorPuntosPrograma,
              puntoPrograma: dailyWorkReport?.puntoPrograma,
              unidadMedida: dailyWorkReport?.unidadMedida,
              eventoSigla: dailyWorkReport?.eventoSigla,
              isApproval: true
            },
            editCSA: true,
            dateSelect: selectedDate
          });
        }
      } else {
        await approve(dailyWorkReport?.idParteDiario);
        fetchData();
      }
    } catch (err) {
      setNewToast({
        type: 'ERROR',
        message: err.message
      });
    } finally {
      setDisableButton(false);

      setLoader(false);
    }
  };

  return (
    <ConditionalWrapper
      condition={todayOlderThanSelectedDate}
      wrapper={(children) => (
        <OverlayTrigger
          delay={{
            show: 250,
            hide: 400
          }}
          overlay={<Tooltip id="approve-approver">Linea con fecha posterior a la actual</Tooltip>}
          placement="top"
        >
          {children}
        </OverlayTrigger>
      )}
    >
      <div>
        <div className="action-button-container">
          <button
            aria-label="Aprobar"
            className="accept-button"
            disabled={disabledButton || todayOlderThanSelectedDate}
            onClick={AcceptQuantity}
            type="button"
          >
            <BsCheckLg size={12} />
          </button>
        </div>
      </div>
    </ConditionalWrapper>
  );
};

export default AcceptButton;

AcceptButton.propTypes = {
  dailyWorkReport: partesTrabajoDiarioItemsWorkReport,
  fetchData: PropTypes.func,
  selectedDate: PropTypes.string.isRequired
};

AcceptButton.defaultProps = {
  dailyWorkReport: {},
  fetchData: () => {}
};
